module.exports = __webpack_public_path__ + "static/media/pause.c616ed74.svg";